<template>
  <el-card v-loading="loading">
    <!-- <el-row type="flex" class="row-bg" justify="center"> -->
    <div id="page-panel">
      <div class="customer-top-nav">
        <div class="title">
          <span>{{$t('reports.names.'+reportCode)}}</span><br>
        </div>
        <div class="controls no-print">
          <!-- <el-switch
            active-text="Afficher détail"
            v-model="showDetail"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch> -->
          <el-dropdown size="small" type="default" class="">
            <el-button type="primary" size="small">
              <i class="el-icon-download"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item @click.native="downloadReport('pdf')"><i class="mdi mdi-file-pdf"/> PDF</el-dropdown-item> -->
              <el-dropdown-item @click.native="downloadReport('csv')"><i class="mdi mdi-file-excel"/> CSV</el-dropdown-item>
              <el-dropdown-item @click.native="downloadReport('csv', true)"><i class="mdi mdi-file-excel"/> CSV détaillé</el-dropdown-item>
              <el-dropdown-item @click.native="downloadReport('QUICKBOOKS', true)"><i class="mdi mdi-file-excel"/> Export Quickbooks</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
  				 <el-button type="primary" @click="openFilterDialog" size="small"><i class="mdi mdi-filter"></i> </el-button>
  			</div>
      </div>

      <p>
        <span class="fs-14 secondary-text">{{companyName}}</span><br>
        <span class="fs-14 secondary-text">{{currentFilterPeriod}}</span><br>
        <span class="fs-14 secondary-text" v-if="customerName!=null && customerName!='' && filters.customerId!=null">Client sélectionné : {{customerName}}</span>
        <span class="fs-14 secondary-text" v-else>Tous les clients</span><br>
        <span v-if="this.filters.paidAt === 'false'">
          <span class="fs-14 secondary-text" v-if="statusCode!=null && statusCode.length>0">Statut(s) sélectionné(s) : <el-tag v-for="status in statusCode" :key="filters.code" size="mini" :type="getInvoiceTagType(status)" style="margin-left:10px;"> {{$t("invoices.statuses."+status.code)}}</el-tag></span>
          <span class="fs-14 secondary-text" v-else>Tous les  statuts</span>
        </span>
      </p>
      <div id="printMe">
        <el-table :data="summary" style="width:100%" ref="summary" :cell-style="{padding:'4px'}" class="mb-60">
          <el-table-column  align="left" label="Sommaire">
            <template slot-scope="scope">
              <span class="fs-14" v-bind:class="{'secondary-text' : !scope.row.header, 'pl-30' : !scope.row.header}">{{$t('reports.INVOICES_DETAIL.headers.'+scope.row.name)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" v-for="cur in currencies" :label="cur">
            <template slot-scope="scope">
              <span class="fs-14" v-bind:class="{'secondary-text' : !scope.row.header}">{{formatAmount(scope.row[cur], cur)}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="tooManyResults" class="text-center bg-warning-lighter p-20 fs-18">
          <i class="el-icon-warning-outline"> </i>
          <span> Il y a trop de facture pour les afficher à l'écran</span>
          <p>Veuillez télécharger le rapport en format <el-button type="text" @click="downloadReport('pdf')">PDF</el-button> ou<el-button type="text" @click="downloadReport('csv')">CSV</el-button></p>
        </div>
        <InvoiceDetailInvoicesView v-if="filters.groupBy=='INVOICE' && !loading && !tooManyResults" :invoices="data.details" :filters="filters" :showDetail="showDetail"></InvoiceDetailInvoicesView>
        <InvoiceDetailCustomerView v-if="filters.groupBy=='CUSTOMER' && !loading && !tooManyResults" :customers="data.details" :filters="filters"></InvoiceDetailCustomerView>

      </div>
    <reportFilter :visible="reportFilterVisible"
                  @close="closeFilterDialog"
                  :predefinedPeriod="predefinedPeriod"
                  :groups="groups"
                  :group="this.filters.groupBy"
                  :period="period"
                  :startDate="this.filters.startDate"
                  :endDate="this.filters.endDate"
                  :statusesCollection="invoiceStatuses"
                  statusType='invoices.statuses'
                  :statuses="this.filters.statuses"
                  :customerFilter="true"
                  :customer="selectedCustomer"
                  :showReportLevel="false"
                  :detailed="filters.detailed"
                  :customer_classes="customerClasses"
                  :reps="filterUserWithRoleRep"
                  :selectedReps="getUserById(filters.selectedReps)"
                  :showDateBy="true"
                  :paidAt="this.filters.paidAt==='true'"
                  @applyFilter="handleFilter">
    </reportFilter>
    <WatingDialog :visible="downloading || loading" content="Veuillez patienter pendant que nous préparons votre rapport. Cela peut prendre plusieurs secondes."></WatingDialog>
</div>
<!-- </el-row> -->
</el-card>
</template>
<script>
//import Section
import salesAPI from '@/services/API/sales.js'
import invoiceAPI from '@/services/API/invoice.js'
import systemAPI from '@/services/API/system.js'
import moment from 'moment'
import reportFilter from './report-filter'
import reportUtil from '@/utils/report-util.js'
import InvoiceDetailCustomerView from './invoices_detail_customer_view'
import InvoiceDetailInvoicesView from './invoices_detail_invoices_view'
import CustomerUtil from '@/utils/customer-util'
import WatingDialog from '@/components/waiting-dialog'
import { mapActions, mapState, mapGetters } from 'vuex';
import portausUtils from '@/utils/portaus-utils';

export default {
  name : "report-invoices",
  props : {
    width : {
      type : Number,
      default : 100
    },
    fiscalEndDay : Number,
    fiscalEndMonth : Number,
    lastFiscalYearDate : Object,
    fiscalYearDate : Object,
    month : Object,
    lastMonth : Object,
    companyName : '',
  },
  data() {
    return {
      showDetail: false,
      tooManyResults : false,
      output : null,
      data : [],
      loading:true,
      statusCode : [],
      filters : {
        range : null,
        startDate : null,
        endDate : null,
        paidAtStartDate : null,
        paidAtEndDate : null,
        paidAt : null,
        statuses : [],
        customerId : null,
        groupBy : 'CUSTOMER',
        detailed : true,
        customerClasses: [],
        selectedReps : [],
      },
      customerName : null,
      reportFilterVisible : false,
      pageWidth : null,
      pageHeight : null,
      downloading : false,
    };
  },
  components : {
    reportFilter,
    InvoiceDetailCustomerView,
    InvoiceDetailInvoicesView,
    WatingDialog
  },
  computed : {
    selectedCustomer(){
      if(this.filters.customerId!=null && this.filters.customerId!=undefined){
        return {id:this.filters.customerId}
      }else{
        return null;
      }
    },
    tableWidth(){
      return 'width : ' + this.width + 'px;';
    },
    currentFilterPeriod(){
      return reportUtil.currentFilterPeriod(this.fiscalYearDate,this.lastFiscalYearDate,this.filters.range,this.filters.startDate,this.filters.endDate, this.filters.paidAtStartDate, this.filters.paidAtEndDate)
    },
    predefinedPeriod(){
      if(this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        return [
          {code : 'MONTH', description:this.month.startDate.format('DD MMM YYYY') + '-'+this.month.endDate.format('DD MMM YYYY')},
          {code : 'LAST_MONTH', description:this.lastMonth.startDate.format('DD MMM YYYY') + '-'+this.lastMonth.endDate.format('DD MMM YYYY')},
          {code : 'FISCAL_YEAR',description:this.fiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.fiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'LAST_FISCAL_YEAR',description:this.lastFiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.lastFiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'CUSTOM', range:true}
        ]
      }else{
        return [];
      }

    },
    period(){
      return _.find(this.predefinedPeriod, p=>{return p.code==this.filters.range})
    },
    reportCode(){
      return this.$route.params.code;
    },
    total(){
      let total = 0.00;
      _.forEach(this.data, p=>{
        total+=p.amount;
      })
      return Math.round(total*100)/100;
    },
    currencies(){
      const currencies = [];
      _.forIn(_.get(this.data, 'summary'), (values, key) => {
        currencies.push(key);
      })
      return currencies.sort();
    },
    summary(){
      // let totalInvoiced = this.data.length>0 ? this.data[0].summary.invoiced : 0.00;
      // let totalPaid = this.data.length>0 ? this.data[0].summary.paid : 0.00;
      // let totalCredited = this.data.length>0 ? this.data[0].summary.credited : 0.00;
      // let amountDue = Math.round((totalInvoiced - (totalPaid + totalCredited))*100)/100;
      let data = [
        // {name:'total_invoiced', header:false, total:12},
        // {name:'total_paid', header:false, total:13},
        // {name:'total_credited', header:false, total:14},
        // {name:'amountDue', header:true, total:15}
      ]

      const totalInvoiced = {
        name: 'total_invoiced',
        haeder: false,
      }
      const totalCredited = {
        name: 'total_credited',
        haeder: false,
      }

      const totalPaid = {
        name: 'total_paid',
        haeder: false,
      }

      const totalDraft = {
        name: 'total_draft',
        haeder: false,
      }

      const totalOutstanding = {
        name: 'total_outstading',
        haeder: false,
      }

      const totalVoid = {
        name: 'total_voided',
        haeder: false,
      }

      const totalTaxes = {
        name: 'total_taxes',
        haeder: false,
      }

      // const income = {
      //   name: 'income',
      //   haeder: false,
      // }

      _.forEach(this.currencies, cur => {
        totalInvoiced[cur] = this.data.summary[cur].totalInvoiced;
        totalCredited[cur] = this.data.summary[cur].totalCredited;
        totalPaid[cur] = this.data.summary[cur].totalPaid;
        totalDraft[cur] = this.data.summary[cur].totalDraft;
        totalVoid[cur] = this.data.summary[cur].totalVoid;
        totalOutstanding[cur] = this.data.summary[cur].totalOutstanding;
        totalTaxes[cur] = this.data.summary[cur].totalTaxes;
        // income[cur] = this.data.summary[cur].income;
      })

      data.push(totalDraft);
      data.push(totalVoid);
      data.push(totalInvoiced);
      data.push(totalPaid);
      data.push(totalCredited);
      data.push(totalTaxes);
      data.push(totalOutstanding);
      // data.push(income);
      

      return data;

    },
    groups(){
      return ['CUSTOMER','INVOICE']
    },
    usableData(){
      return this.data;
    },
    ...mapState('statuses',['invoiceStatuses']),
    ...mapGetters('invoices',['getInvoiceTagType']),
    ...mapState('controlData',['customerClasses']),
    ...mapGetters('users',['filterUserWithRoleRep', 'getUserById']),

  },
  methods : {
    formatAmount(amount, currency) {
          return portausUtils.formatAmount(amount, this.$i18n.locale, currency) ;
		},
    downloadReport(format, detailed = false){
      this.downloading=true;
      let filters = this.prepareFilterForRequest();
      filters.format=format
      filters.detailed = detailed;

      let filename = 'INVOICES_REPORT_'+moment(this.filters.startDate || this.filters.paidAtStartDate).format('YYYY-MM-DD')+'-'+moment(this.filters.endDate || this.filters.paidAtEndDate).format('YYYY-MM-DD');
      filename+="."+format;
      if (format === 'QUICKBOOKS') {

      return invoiceAPI.downloadQuickbooksExtractInvoicesCSV(filters, filename)
        .then(()=>{
          this.downloading=false;
        }).catch(err=>{
          this.downloading=false;
          this.$message.error("Oops... Une erreur est survenue!");
        })
      } else {
        return salesAPI.downloadSalesReport(this.reportCode, filename, filters)
        .then(()=>{
          this.downloading=false;
        }).catch(err=>{
          this.downloading=false;
          this.$message.error("Oops... Une erreur est survenue!");
        })
      }

      
    },
    getCustomerName(name, usual_name){
      return CustomerUtil.customerName(name, usual_name);
    },
    // print(){
    //    const element = window.document.getElementById('page-panel');

    //    _.forEach(element.getElementsByTagName('table'), t=>{
    //      t.style.width='100%';
    //      t.style['table-layout']='auto';
    //    })
    //    const url = '';
    //    const win = window.open('', '', 'left=0,top=0,width=800,height=800,toolbar=yes,scrollbars=yes,status=yes', true);

    //     // Get all stylesheets HTML
    //     let stylesHtml = '';
    //     for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
    //       stylesHtml += node.outerHTML;
    //     }
    //     win.document.write(`
    //     <html style="overflow-x: hidden;overflow-y: auto;height:100%;width:100%;display:block;position:unset">
    //       <head>
    //         <title>${window.document.title}</title>
    //         <styles>${stylesHtml}</styles>
    //       </head>
    //       <body style="overflow-x: hidden;overflow-y: auto;height:auto;width:100%;display:block;position:unset;">
    //         ${element.innerHTML}
    //       </body>
    //     </html>
    //   `);
    //   setTimeout(() => {
    //     win.document.close();
    //     win.focus();
    //     win.print();
    //     win.close();
    //   }, 1000);


    // },
    openCustomer(customerId){
      var index='/customers/'+customerId;
			this.$router.push(index);
    },
    _moment(date, format='l'){
      return moment(date).format(format);
    },
    handleFilter(filters){
      localStorage.invoices_detail_paidAt = filters.dateByPaidAt;
      localStorage.invoices_detail_detailed = filters.detailed;
      localStorage.invoices_detail_groupBy=filters.group;
      localStorage.invoices_detail_range=filters.period.code;
      localStorage.invoices_detail_startDate = filters.dateRange[0];
      localStorage.invoices_detail_endDate = filters.dateRange[1];

      localStorage.invoices_detail_customerId = filters.customer!=null ? filters.customer.id : undefined;


      if(localStorage.invoices_detail_statuses==null){
        localStorage.invoices_detail_statuses=JSON.stringify([]);
      }

      let customer_classes = [];
      _.forEach(filters.customer_classes, m=>{
        customer_classes.push(m.id);
      })
      localStorage.invoices_detail_customer_classes = JSON.stringify(customer_classes);

      let repIds = [];
      _.forEach(filters.reps, r=>{
        repIds.push(r.id);
      })
      localStorage.invoices_detail_reps_id = JSON.stringify(repIds);

      this.filters.statuses=JSON.parse(localStorage.invoices_detail_statuses);

      if(filters.customer!=null){
        localStorage.invoices_detail_customerName = this.getCustomerName(filters.customer.name,filters.customer.usual_name);
      }else{
        delete localStorage.invoices_detail_customerName;
      }
      let statuses = [];
      this.statusCode=[];
      _.forEach(filters.statuses, s=>{
        this.statusCode.push(s);
        statuses.push(s.id);
      })
      localStorage.invoices_detail_statuses = JSON.stringify(statuses);

      this.setFilters();
      this.fetchData();
    },
    openFilterDialog(){
      this.reportFilterVisible = true;
    },
    closeFilterDialog(){
      this.reportFilterVisible=false;
    },
    getRealPeriodNumber(falseNumber){
      let number = falseNumber;
      if(falseNumber>12){
        number-=12;
      }
      return number;
    },
    showPeriodName(periodNumber){
      if(this.filters.groupBy=='MONTH'){
        return moment().month(this.getRealPeriodNumber(periodNumber)).format('MMM');
      }else{
        let realPeriodNumber= this.getRealPeriodNumber(periodNumber);
        let startMonth = moment().month(((realPeriodNumber+1)*3)-3).format('MMM');
        let endMonth = moment().month(((realPeriodNumber+1)*3)-1).format('MMM');
        return startMonth + '-' + endMonth
      }

    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        if(row.span){
          return {rowspan:1, colspan:this.nbColums+2}
        }else{
          return {rowspan:1, colspan:1}
        }
      },

		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
  			this.setPageWidth();
  		}, 700),
    prepareFilterForRequest(){
      let filters = _.cloneDeep(this.filters);
      if(filters.startDate!=null){
        filters.startDate = moment(filters.startDate).format('YYYY-MM-DD Z');
      }
      if(filters.endDate!=null){
        filters.endDate = moment(filters.endDate).format('YYYY-MM-DD Z');
      }

      if(filters.paidAtStartDate!=null){
        filters.paidAtStartDate = moment(filters.paidAtStartDate).format('YYYY-MM-DD Z');
      }
      if(filters.paidAtEndDate!=null){
        filters.paidAtEndDate = moment(filters.paidAtEndDate).format('YYYY-MM-DD Z');
      }

      filters.repId = [];
      _.forEach(filters.selectedReps, (r) => {
        filters.repId.push(r);
      })
      delete filters.selectedReps;

      return filters;
    },
    fetchData(){
      this.loading = true;
      this.totalPayments = 0.00;
      let filters = this.prepareFilterForRequest();
      return salesAPI.getReportInfo(this.reportCode, filters)
        .then(data=>{
          // this.tooManyResults = (this.filters.detailed && data.length>100) || (!this.filters.detailed && data.length>1000) ? true : false;
          this.data = data;

          this.loading = false;
        }).catch(err=>{
          console.log(err);
          this.loading = false;
          this.$message.error('Une erreur système est survenue. Veuillez réessayer plus tard')
        })
    },
    setFilters(){
      this.filters.paidAt = localStorage.invoices_detail_paidAt;
      if(localStorage.invoices_detail_range==null){
        localStorage.invoices_detail_range='MONTH';
      }
      this.customerName = localStorage.invoices_detail_customerName;
      if(localStorage.invoices_detail_groupBy==null){
        localStorage.invoices_detail_groupBy='CUSTOMER';
      }
      this.filters.detailed = localStorage.invoices_detail_detailed==null || localStorage.invoices_detail_detailed=='false' ? false : true;
      this.filters.groupBy = localStorage.invoices_detail_groupBy;
      this.filters.range=localStorage.invoices_detail_range;

      this.filters.customerId=localStorage.invoices_detail_customerId!='undefined' && localStorage.invoices_detail_customerId!=null  ? parseInt(localStorage.invoices_detail_customerId) : undefined;

      this.filters.statuses=localStorage.invoices_detail_statuses!=null?JSON.parse(localStorage.invoices_detail_statuses):[];

      if(this.filters.range=='FISCAL_YEAR' && this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        localStorage.invoices_detail_startDate = this.fiscalYearDate.startDate;
        localStorage.invoices_detail_endDate = this.fiscalYearDate.endDate;
      }else if(this.filters.range=='LAST_FISCAL_YEAR' && this.lastFiscalYearDate.startDate!=null && this.lastFiscalYearDate.endDate!=null){
        localStorage.invoices_detail_startDate = this.lastFiscalYearDate.startDate;
        localStorage.invoices_detail_endDate = this.lastFiscalYearDate.endDate;
      }else if(this.filters.range=='MONTH'){
        localStorage.invoices_detail_startDate = this.month.startDate;
        localStorage.invoices_detail_endDate = this.month.endDate;
      }else if(this.filters.range=='LAST_MONTH'){
        localStorage.invoices_detail_startDate = this.lastMonth.startDate;
        localStorage.invoices_detail_endDate = this.lastMonth.endDate;
      }

      if (this.filters.paidAt === 'true') {
        this.filters.paidAtStartDate = localStorage.invoices_detail_startDate;
        this.filters.paidAtEndDate = localStorage.invoices_detail_endDate;
        this.filters.startDate = null;
        this.filters.endDate = null;
      } else {
        this.filters.paidAtStartDate = null;
        this.filters.paidAtEndDate = null;
        this.filters.startDate = localStorage.invoices_detail_startDate;
        this.filters.endDate = localStorage.invoices_detail_endDate;
      }

      this.filters.customerClasses=localStorage.invoices_detail_customer_classes!=null ? JSON.parse(localStorage.invoices_detail_customer_classes) : [];
      this.filters.selectedReps=localStorage.invoices_detail_reps_id!=null ? JSON.parse(localStorage.invoices_detail_reps_id) : [];

    },
    ...mapActions('statuses',['fetchInvoiceStatuses']),
    ...mapActions('controlData', ['fetchCustomerClasses']),
    ...mapActions('users', ['fetchAdminUsers']),

  },
  mounted(){
    this.setPageWidth();
    this.$refs.summary.$options._parentVnode.elm.classList.remove('el-table--enable-row-hover')
  },
  beforeDestroy(){
    this.data = [];
  },
  created(){
    this.loading = true;
    this.setFilters();
    this.fetchInvoiceStatuses();
    this.fetchCustomerClasses();
    this.fetchData();
    this.fetchAdminUsers();
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

@media print {
  body, html { margin-top:0%;
    font-size:0.8em;
     display:block;
     height:100%;
     width:100%;
     position:unset !important;
     background:none;
     overflow-x: hidden;overflow-y: auto;height:100%;width:100%;display:block;position:unset
   }
   .no-print{
   	display:none;
   }
   .el-card{
     border:none;
     width:100%;
   }

   @page {
     size: portrait;
   }


}
.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:40px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}


</style>
